<!-- components/wallet/TransactionsOverview.vue -->
<template>
  <div class="transactions-overview-section">
    <h5 class="ml-3 mb-3">Overview</h5>
    <div class="row g-4">
      <div class="col-md-4" v-for="(item, index) in stats" :key="index">
        <div
          class="overview-card p-4 d-flex justify-content-between align-items-center"
        >
          <div>
            <p class="card-heading mb-3">{{ item.label }}</p>
            <h4 class="mb-3 fw-bold num-value">
              {{ item.value }}
              <span class="text-secondary" v-if="item.unit">{{
                item.unit
              }}</span>
            </h4>
            <small class="text-muted">{{ item.subtext }}</small>
          </div>
          <div class="icon-circle bg-light">
            <img :src="item.icon" :alt="item.label" width="24" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransactionsOverview",
  props: {
    stats: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.transactions-overview-section {
  background-color: #e2e6eb;
  padding: 48px 100px 56px 100px;
  font-family: Inter;
}

.transactions-overview-section h5 {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  line-height: 31.5px;
}

.overview-card {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  border-radius: 6px;
}

.num-value {
  font-weight: 700;
  font-size: 32px;
}

.card-heading {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e2e6eb !important;
}
</style>
